import { Pager } from "../common/pagination.model";

export interface UserRole {
  role: string;
}

export interface UserRecord {
  id: string;
  full_name: string;
  username?:string|null;
  email: string;
  createdAt: string;   // ISO date string
  last_seen: string;   // ISO date string
  user_roles: UserRole[];
}

export interface UserRecordsResponse extends Pager {
  records: UserRecord[];
}